import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { isBefore } from "date-fns";

export const appl70ValidationSchema = () => {
  const { t } = useTranslation();
  const comparisonDate = new Date(1900, 0, 1);
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    mergePlanDate: yup
      .date().typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .test(
        "is-after-1900",
        t(
          "Ελέγξτε την ημερομηνία των πρακτικών του ΔΣ για την έναρξη των εργασιών. Η ημερομηνία θα πρέπει να έχει τη μορφή ΗΗ/ΜΜ/ΥΥΥΥ (π.χ. 30/03/2022)."
        ),
        function (value) {
          return value && !isBefore(value, comparisonDate);
        }
      ),
    fudocMergePlan: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    acquiredCompany: yup
      .array()
      .min(
        1,
        t("Προσοχή! Πρέπει η επιχείρησή σας να μετέχει στο σχέδιο σύμβασης.")
      ),
  });
};
